import { Content, Header, Item, Root, Trigger } from '@radix-ui/react-accordion';
import { forwardRef } from 'react';
import classNames from '@/lib/classNames';
import { Icon } from '../../global/Icons';

const Accordion = Root;

const AccordionItem = forwardRef<React.ElementRef<typeof Item>, React.ComponentPropsWithoutRef<typeof Item>>(({ className, ...props }, ref) => (
    <Item ref={ref} className={classNames('border-2 text-primary rounded-xl my-2', className)} {...props} />
));
AccordionItem.displayName = 'AccordionItem';

const AccordionTrigger = forwardRef<React.ElementRef<typeof Trigger>, React.ComponentPropsWithoutRef<typeof Trigger>>(({ className, children, ...props }, ref) => (
    <Header className="flex w-full">
        <Trigger ref={ref} className={classNames('w-full h-full py-6 px-6 transition-all hover:underline [&[data-state=open]>span>svg]:rotate-45', className)} {...props}>
            <span className="w-full h-full grid grid-cols-[1fr_1.25rem] gap-5 items-center">
                {children}
                <Icon id="plus" className="w-5 h-5 transition-transform duration-200 fill-primary" />
            </span>
        </Trigger>
    </Header>
));
AccordionTrigger.displayName = Trigger.displayName;

const AccordionContent = forwardRef<React.ElementRef<typeof Content>, React.ComponentPropsWithoutRef<typeof Content>>(({ className, children, ...props }, ref) => (
    <Content
        ref={ref}
        className={classNames('overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down', className)}
        {...props}
    >
        <div className="pb-4 pt-0 px-6 ">{children}</div>
    </Content>
));
AccordionContent.displayName = Content.displayName;

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger };
